module.exports = __webpack_public_path__ + "img/icon_radio@3x.6111136a.png";